import { GxSpinner } from '@garpix/garpix-web-components-react'
import React from 'react'
import style from './styles/spinner.module.scss'

const PageSpinner = (): React.ReactElement => {
  return (
    <div className={style.container}>
      <GxSpinner className={style.spinner_red} />
    </div>
  )
}

export default PageSpinner
